import { HeadCell, PAYMENT_TYPE } from 'models';

export const headCells: readonly HeadCell<PAYMENT_TYPE>[] = [
  {
    id: 'timestamp',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'TXN Datetime',
  },
  {
    id: 'number',
    numeric: false,
    disablePadding: true,
    isSort: true,
    label: 'TXN No.',
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'TXN Type',
  },
  {
    id: 'user',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'User',
  },
  {
    id: 'doc_ref_no',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Doc Ref No.',
  },
  {
    id: 'total_amount',
    numeric: true,
    disablePadding: false,
    isSort: true,
    label: 'Total Amount',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Status',
  },
  {
    id: 'walletTransaction',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Wallet Ref.',
  },
];
